import React, {useState} from 'react';
import {Helmet} from 'react-helmet-async';


// Eigene Komponenten
import NewsletterSection from '../../components/NewsletterSection/index';
import GreenEnergySection from "../../components/GreenEnergySection/GreenEnergySection";
import EcoMission from "../../components/OurMission/EcoMission";
import HeroSection from '../../components/HeroSection/index';

//import DraggableGlossyCloud from '../../components/DraggableGlossyCloud/index';

// Assets (Logos usw.)
import Keycloak from '../../assets/images/logos/keycloak.png';
import Qdrant from '../../assets/images/logos/qdrant.png';
import MySQL from '../../assets/images/logos/mysql.png';
import MongoDB from '../../assets/images/logos/mongodb.png';
//import Ceph from '../../assets/images/logos/ceph.png';
/*
const CloudSVG = ({ className = '' }) => (
    <svg
        viewBox="0 0 64 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M19.187 18.348c-.079-.477-.119-.965-.119-1.461 0-4.338 3.555-7.864 7.93-7.864 3.49 0 6.466 2.167 7.52 5.166a5.003 5.003 0 0 1 1.273-.166c2.768 0 5.016 2.22 5.016 4.962 0 .216-.017.429-.048.638 2.404.261 4.261 2.229 4.261 4.673 0 2.591-2.162 4.698-4.827 4.698H22.85c-3.558 0-6.443-2.85-6.443-6.367 0-2.678 1.691-4.974 4.079-5.279z"
            fill="currentColor"
        />
    </svg>
);
*/
const Home = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupType, setPopupType] = useState(null); // 'moreInfo' oder 'newsletter'

    const togglePopup = () => {
        setIsPopupOpen(!isPopupOpen);
    };

    const closePopup = () => {
        setPopupType(null);
    };

    return (
        <>
            <Helmet>
                {/* Titel der Startseite */}
                <title>Cloudtal – Open Source Cloud-Dienste</title>

                {/* Meta-Beschreibung für SEO */}
                <meta
                    name="description"
                    content="Cloudtal bietet Ihnen DSGVO-konforme und in Deutschland gehostete Open Source Cloud-Dienste wie PostgreSQL und Keycloak. Skalierbar, sicher und leistungsstark."
                />

                {/* Meta-Keywords für bessere Auffindbarkeit */}
                <meta
                    name="keywords"
                    content="Cloud-Dienste, Open Source, PostgreSQL, Keycloak, DSGVO, Hosting, Deutschland, Managed Services"
                />

                {/* Autor und Viewport für Mobilgeräte */}
                <meta name="author" content="Cloudtal Team"/>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"/>

                {/* Open Graph Meta-Tags für bessere Darstellung auf Social Media */}
                <meta property="og:title" content="Cloudtal – Open Source Cloud-Dienste"/>
                <meta property="og:site_name" content="Cloudtal"/>
                <meta
                    property="og:description"
                    content="DSGVO-konforme, sichere und leistungsstarke Cloud-Dienste wie PostgreSQL und Keycloak – gehostet in Deutschland."
                />
                <meta property="og:type" content="website"/>
                <meta property="og:url" content="https://www.cloudtal.de"/>

                {/* Canonical URL zur Vermeidung von Duplicate Content */}
                <link rel="canonical" href="https://www.cloudtal.de"/>
            </Helmet>

            <main className="flex-1 relative z-10">
                {/* HERO / TOP SECTION - SEHR GROSSE ABSTÄNDE */}
                <HeroSection/>

                {/* Popups */}
                {popupType === 'newsletter' && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                        <div className="bg-zinc-900 rounded-lg p-8 max-w-lg w-full text-center shadow-xl mx-4">
                            <h3 className="text-3xl font-bold mb-4 text-zinc-100">Newsletter-Anmeldung</h3>
                            <p className="mb-6 text-zinc-400">
                                Es geht bald los! Melden Sie sich an, um die neuesten Informationen
                                und exklusive Angebote zu erhalten.
                            </p>
                            <NewsletterSection
                                title=""
                                description=""
                                placeholder="Ihre E-Mail-Adresse"
                                buttonText="Anmelden"
                                privacyText="Wir respektieren Ihre Privatsphäre. Abmeldung jederzeit möglich."
                                additionalClassName="!p-0 mb-4"
                            />
                            <button
                                onClick={closePopup}
                                className="
                    mt-4
                    bg-zinc-800
                    text-zinc-200
                    px-6
                    py-2
                    rounded
                    transition-transform
                    duration-300
                    hover:scale-105
                  "
                            >
                                Schließen
                            </button>
                        </div>
                    </div>
                )}

                {popupType === 'moreInfo' && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                        <div className="bg-zinc-900 rounded-lg p-8 max-w-2xl w-full text-center shadow-xl mx-4">
                            <h3 className="text-3xl font-bold mb-6 text-zinc-100">Weitere Informationen</h3>
                            <p className="mb-6 text-zinc-400">
                                Cloudtal bietet dir modernste Cloud-Dienste, die auf Leistung,
                                Skalierbarkeit und Sicherheit ausgelegt sind. Entdecken Sie,
                                wie wir Ihre Infrastruktur transformieren können.
                            </p>
                            <ul className="list-disc list-inside text-left text-zinc-400 space-y-1">
                                <li>Leistungsstarke PostgreSQL-Datenbanken</li>
                                <li>DSGVO-konforme Cloud-Services</li>
                                <li>Skalierbare Lösungen für Ihr Unternehmen</li>
                                <li>Verlässliche Uptime und Sicherheit</li>
                                <li>Zukünftige Erweiterungen: Serverless-Dienste für maximale Flexibilität</li>
                                <li>Neue verwaltete Dienste wie Elasticsearch, Kubernetes und mehr in Planung</li>
                            </ul>
                            <button
                                onClick={closePopup}
                                className="
                    mt-6
                    bg-zinc-800
                    text-zinc-200
                    px-6
                    py-2
                    rounded
                    transition-transform
                    duration-300
                    hover:scale-105
                  "
                            >
                                Schließen
                            </button>
                        </div>
                    </div>
                )}

                {/* POSTGRESQL SECTION */}
                <section className="relative w-full py-48 md:py-64 lg:py-80 bg-black">

                    <div className="container px-4 md:px-6 mx-auto">
                        <div className="flex flex-col items-center text-center space-y-12">
                            <div className="mx-auto space-y-4">
                                <h2 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl text-zinc-100 border-2 py-3 px-4 rounded-3xl border-green-300">
                                    Unser erstes Produkt: <span
                                    className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-t from-green-300 to-green-100">PostgreSQL</span>
                                </h2>
                                <p className="text-zinc-300 text-lg sm:text-xl mx-auto leading-relaxed max-w-2xl">
                                    Leistungsstarke, skalierbare und vollständig
                                    verwaltete PostgreSQL-Datenbanken für Ihre anspruchsvollsten Anwendungen.
                                    <span className={""}>Verfügbar als Serverless oder Managed Service.</span>
                                </p>
                            </div>

                            <div className="mx-auto grid max-w-5xl items-center gap-8 md:gap-12 md:grid-cols-2 w-full">
                                <div className="flex flex-col justify-center space-y-6 text-left">
                                    <ul className="space-y-6 text-zinc-400">
                                        <li>
                                            <div className="space-y-1">
                                                <h3 className="text-xl font-bold text-zinc-100">Hochverfügbar</h3>
                                                <p>99,9% Uptime-Garantie für Ihre kritischen Daten.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="space-y-1">
                                                <h3 className="text-xl font-bold text-zinc-100">DSGVO-konform</h3>
                                                <p>Alle Daten werden sicher in Deutschland gehostet.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="space-y-1">
                                                <h3 className="text-xl font-bold text-zinc-100">Skalierbar</h3>
                                                <p>Wachsen Sie nahtlos mit Ihren Anforderungen.</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex justify-center sm:justify-end">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-database h-24 w-24 text-green-500 sm:h-52 sm:w-52"
                                    >
                                        <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                                        <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                                        <path d="M3 12a9 3 0 0 0 18 0"></path>
                                    </svg>
                                </div>
                            </div>

                            <button
                                onClick={togglePopup}
                                className="
                    bg-zinc-800
                    text-zinc-200
                    px-6
                    py-3
                    rounded
                    transition-transform
                    duration-300
                    hover:scale-105
                  "
                            >
                                Weitere Produkte
                            </button>
                        </div>
                    </div>

                    
                </section>

                {/* Popup für "Weitere Produkte" */}
                {isPopupOpen && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                        <div className="bg-zinc-900 rounded-lg p-8 max-w-2xl w-full text-center shadow-xl mx-4">
                            <h3 className="text-3xl font-bold mb-6 text-zinc-100">
                                Open Source Cloud Native Produkte
                            </h3>
                            <p className="mb-6 text-zinc-400">
                                Diese leistungsstarken Open Source Cloud Native Produkte werden bald
                                verfügbar sein, um Ihre Infrastruktur noch effizienter zu gestalten.
                            </p>

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-6">
                                {/* Produkt 1 */}
                                <div className="flex flex-col items-center">
                                    <div className="h-20 w-20 mb-2 flex justify-center items-center">
                                        <img src={Keycloak} alt="Keycloak"/>
                                    </div>
                                    <span className="text-zinc-300 font-medium">Keycloak</span>
                                </div>
                                {/* Produkt 2 */}
                                <div className="flex flex-col items-center">
                                    <div className="h-20 w-20 mb-2 flex justify-center items-center">
                                        <img src={Qdrant} alt="Qdrant"/>
                                    </div>
                                    <span className="text-zinc-300 font-medium">Qdrant</span>
                                </div>
                                {/* Produkt 3 */}
                                <div className="flex flex-col items-center">
                                    <div className="h-20 w-20 mb-2 flex justify-center items-center">
                                        <img src={MySQL} alt="MySQL"/>
                                    </div>
                                    <span className="text-zinc-300 font-medium">MySQL</span>
                                </div>
                                {/* Produkt 4 */}
                                <div className="flex flex-col items-center">
                                    <div className="h-20 w-20 mb-2 flex justify-center items-center">
                                        <img src={MongoDB} alt="MongoDB"/>
                                    </div>
                                    <span className="text-zinc-300 font-medium">MongoDB</span>
                                </div>
                            </div>

                            <button
                                onClick={togglePopup}
                                className="
                    bg-zinc-800
                    text-zinc-200
                    px-6
                    py-3
                    rounded
                    transition-transform
                    duration-300
                    hover:scale-105
                  "
                            >
                                Schließen
                            </button>
                        </div>
                    </div>
                )}

                {/* UNSERE DIENSTE */}
                <section className="relative w-full py-48 md:py-64 lg:py-80 bg-black">
                    

                    <div className="container px-4 md:px-6 mx-auto">
                        <div className="flex flex-col items-center text-center space-y-8">
                            <div className="max-w-2xl mx-auto space-y-4">
                                <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl text-white">
                                    Weitere Dienste
                                </h2>
                                <p className="text-zinc-300 text-lg">
                                    Entdecken Sie unsere zukünftige Palette an verwalteten Cloud-Diensten.
                                </p>
                            </div>
                            <div
                                className="mx-auto grid max-w-5xl items-start gap-8 py-8 md:py-12 lg:py-16 lg:grid-cols-3">
                                <div className="flex flex-col items-center space-y-4 text-center px-4">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-database h-12 w-12 text-green-500 mb-2"
                                    >
                                        <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                                        <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
                                        <path d="M3 12A9 3 0 0 0 21 12"></path>
                                    </svg>
                                    <h3 className="text-xl font-bold text-zinc-100">PostgreSQL</h3>
                                    <p className="text-zinc-400 leading-relaxed">
                                        Leistungsstarke, zuverlässige Datenbanklösungen, vollständig verwaltet.
                                    </p>
                                </div>

                                <div className="flex flex-col items-center space-y-4 text-center px-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                         strokeLinejoin="round"
                                         className="lucide lucide-key-round h-12 w-12 text-green-500 mb-2">
                                        <path
                                            d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z"/>
                                        <circle cx="16.5" cy="7.5" r=".5" fill="currentColor"/>
                                    </svg>
                                    <h3 className="text-xl font-bold text-zinc-100">Keycloak</h3>
                                    <p className="text-zinc-400 leading-relaxed">
                                        Einfache und sichere Identitäts- und Zugriffsverwaltung für Ihre Anwendungen.
                                    </p>
                                </div>

                                <div className="flex flex-col items-center space-y-4 text-center px-4">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-plus-circle h-12 w-12 text-green-500 mb-2"
                                    >
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <line x1="12" x2="12" y1="8" y2="16"></line>
                                        <line x1="8" x2="16" y1="12" y2="12"></line>
                                    </svg>
                                    <h3 className="text-xl font-bold text-zinc-100">Weitere Dienste folgen</h3>
                                    <p className="text-zinc-400 leading-relaxed">
                                        Bleiben Sie gespannt auf eine wachsende Liste innovativer Cloud-Dienste.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* WARUM CLOUDTAL? */}
                <section className="relative w-full py-48 md:py-64 lg:py-80 bg-black">
                    

                    <div className="container px-4 md:px-6 mx-auto">
                        <div className="flex flex-col items-center text-center space-y-8">
                            <div className="max-w-2xl mx-auto space-y-4">
                                <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl text-zinc-100">
                                    Warum Cloudtal?
                                </h2>
                                <p className="text-zinc-300 text-lg">
                                    Vertrauen Sie auf deutsche Qualität und Sicherheit für Ihre Cloud-Infrastruktur.
                                </p>
                            </div>
                            <div
                                className="mx-auto grid max-w-5xl items-start gap-8 py-8 md:py-12 lg:py-16 lg:grid-cols-3">
                                <div className="flex flex-col items-center space-y-4 text-center px-4">
                                    <h3 className="text-xl font-bold text-zinc-100">In Deutschland gehostet</h3>
                                    <p className="text-zinc-400 leading-relaxed">
                                        Alle Daten bleiben sicher innerhalb deutscher Grenzen.
                                    </p>
                                </div>
                                <div className="flex flex-col items-center space-y-4 text-center px-4">
                                    <h3 className="text-xl font-bold text-zinc-100">DSGVO-konform</h3>
                                    <p className="text-zinc-400 leading-relaxed">
                                        Volle Übereinstimmung mit europäischen Datenschutzgesetzen.
                                    </p>
                                </div>
                                <div className="flex flex-col items-center space-y-4 text-center px-4">
                                    <h3 className="text-xl font-bold text-zinc-100">99,9% Uptime</h3>
                                    <p className="text-zinc-400 leading-relaxed">
                                        Zuverlässiger Service für Ihre geschäftskritischen Anwendungen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                </section>

                {/* GreenEnergySection und EcoMission (beide auf Schwarz) */}
                <GreenEnergySection/>
                <EcoMission additionalClassName="bg-black text-zinc-200"/>

                {/* NewsletterSection als Abschluss */}
                <NewsletterSection
                    title="Exklusives Beta-Tester-Programm"
                    description="Testen Sie als einer der wenigen unsere Beta-Version und erleben Sie die neuesten Funktionen vor allen anderen. Die Teilnehmerzahl ist streng limitiert – sichern Sie sich jetzt Ihren Platz!"
                    placeholder="Ihre E-Mail-Adresse"
                    buttonText="Jetzt registrieren"
                    privacyText="Wir respektieren Ihre Privatsphäre. Abmeldung jederzeit möglich."
                    additionalClassName="bg-black bg-bottom text-white"
                />
            </main>
        </>
    );
};

export default Home;
